import PrintsCarousel from './PrintsCarousel';

export default function ProvaSocial() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* Título emocional da seção */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-bold tracking-widest text-teal-600 uppercase mb-4">O que dizem quem já aplicou</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Você não está sozinho nessa jornada
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Cuidar de alguém com Alzheimer é exaustivo — mas com o método certo,{' '}
            <span className="text-teal-600 font-semibold">famílias inteiras mudaram a forma de lidar com as crises</span>{' '}
            e voltaram a respirar com mais tranquilidade.
          </p>
        </div>

        {/* Prints de WhatsApp */}
        <PrintsCarousel />

        {/* Vídeo Depoimento */}
        <div className="mt-20">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-bold tracking-widest text-teal-600 uppercase mb-3">Depoimento em vídeo</span>
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">
              "Eu não sabia mais o que fazer — até encontrar esse método"
            </h3>
            <p className="text-gray-500 mt-3 text-base max-w-xl mx-auto leading-relaxed">
              Assista ao relato de quem estava no limite e descobriu como transformar o caos em rotina previsível, com mais calma e segurança.
            </p>
          </div>

          <div className="max-w-3xl mx-auto rounded-2xl overflow-hidden border border-teal-100 bg-black">
            <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
              <iframe
                src="https://player.vimeo.com/video/1145714999"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Depoimento em vídeo"
              ></iframe>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
